<template>
  <div
    class="cat-item mb-1"
    :style="myMenuStyle"
  >
    <!-- <v-container
      v-if="!itemAvailable"
      fill-height
      fluid
      class="sold-out-bg"
    >
      <v-layout
        justify-center
        align-center
      >
        <span class="sold-out-text">{{ $t('sold_out') }}</span>
      </v-layout>
    </v-container> -->
    <v-container
      v-if="item.photo_url"
      :style="myContainerStyle"
    >
      <v-layout
        row
        align-center
      >
        <v-avatar
          :size="catItem.imgSize"
          tile
          @click="orderItem(false)"
        >
          <v-img
            :src="item.photo_url"
            class="food-img"
            @click="orderItem(false)"
          >
            <item-nutri-grade-tag :item="item" />
          </v-img>
        </v-avatar>
        <v-flex
          ml-3
          @click="orderItem"
        >
          <v-layout
            row
            align-center
          >
            <v-flex xs12 @click.stop="orderItem(false)">
              <span
                v-if="itemQtyInCart(item.plu_id) > 0"
                :style="myQtyStyle"
              >{{ itemQtyInCart(item.plu_id) }}x&nbsp;</span>
              <span :style="myNameStyle">{{ itemName }}</span>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex
              v-if="catItem.displayDesc && item.description"
              xs12
              :style="myDescStyle"
              class="nowrap-text"
            >
              {{ item.description }}
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12>
              <span :style="myPriceStyle">{{ $n(item.price, 'currency') }}</span>
              <span
                v-if="!itemAvailable"
                :style="mySoldOutStyle"
              >{{ $t('sold_out') }}</span>
              <span
                v-if="afterPresetDiscountPrice"
                :style="presetDiscountPriceStyle"
              >
                {{ $n(afterPresetDiscountPrice, 'currency') }}
              </span>
            </v-flex>
          </v-layout>
          <v-layout
            v-if="item.featured_icons && item.featured_icons.length > 0"
            row
          >
            <v-flex
              xs12
              class="legends text-xs-right"
            >
              <v-avatar
                v-for="(featured, index) in item.featured_icons"
                class="ml-1"
                tile
                :key="index"
                :src="featured.img"
                size="20"
              >
                <img :src="featured.img" />
              </v-avatar>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container
      v-else
      @click="orderItem"
      :style="myContainerStyle"
    >
      <v-layout
        row
        align-center
      >
        <v-flex xs12  @click.stop="orderItem(false)" style="position: relative">
          <span
            v-if="itemQtyInCart(item.plu_id) > 0"
            :style="myQtyStyle"
          >{{ itemQtyInCart(item.plu_id) }}x&nbsp;</span>
          <span :style="myNameStyle">{{ itemName }}</span>
          <item-nutri-grade-tag :item="item" />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex
          xs12
          v-if="item.description"
          :style="myDescStyle"
          class="nowrap-text"
        >
          {{ item.description }}
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <span :style="myPriceStyle">{{ $n(item.price, 'currency') }}</span>
          <span
            v-if="!itemAvailable"
            :style="mySoldOutStyle"
          >{{ $t('sold_out') }}</span>
          <span
            v-if="afterPresetDiscountPrice && itemAvailable"
            :style="presetDiscountPriceStyle"
          >
                {{ $n(afterPresetDiscountPrice, 'currency') }}
              </span>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="item.featured_icons && item.featured_icons.length > 0"
        row
      >
        <v-flex
          xs12
          class="legends text-xs-right"
        >
          <v-avatar
            v-for="(featured, index) in item.featured_icons"
            class="ml-1"
            tile
            :key="index"
            :src="featured.img"
            size="20"
          >
            <img :src="featured.img" />
          </v-avatar>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import preset_discount from '../mixins/preset_discount'
import ItemNutriGradeTag from './ItemNutriGradeTag.vue'

export default {
  name: 'list-cat-item-component',
  components: {
    'item-nutri-grade-tag': ItemNutriGradeTag
  },
  props: {
    item: {
      type: Object,
      default: () => null
    },
    multiplePlus: {
      type: Boolean,
      default: () => false
    }
  },
  mixins: [preset_discount],
  computed: {
    ...mapGetters('config', [
      'config', 'theme', 'iOS', 'inIframe', 'catItem', 'language',
      'mode'
    ]),
    ...mapGetters('cart', [
      'cart', 'itemQtyInCart', 'cartLimitReached'
    ]),
    ...mapGetters('auth', [
      'user'
    ]),
    myMenuStyle () {
      return {
        backgroundColor: this.theme.submenu_bg_color,
        position: 'relative',
        marginLeft: '1px',
        marginRight: '1px',
        borderRadius: '4px'
      }
    },
    myContainerStyle () {
      return {
        padding: '13px 15px'
      }
    },
    myQtyStyle () {
      let styles = {
        fontSize: '16px'
      }
      if (this.theme.menu_qty_color_inner === this.theme.menu_qty_color) {
        styles.color = this.theme.menu_qty_color
        styles.fontWeight = 750
      } else {
        styles.color = this.theme.menu_qty_color_inner
        styles.textShadow = `-1px 0 ${this.theme.menu_qty_color}, 0 1px ${this.theme.menu_qty_color},
          1px 0 ${this.theme.menu_qty_color}, 0 -1px ${this.theme.menu_qty_color}`
      }
      return styles
    },
    myNameStyle () {
      return {
        fontSize: '16px',
        color: this.theme.menu_subtitle_color,
        fontWeight: 700
      }
    },
    myDescStyle () {
      return {
        fontSize: this.config.itemdesc_fontsize,
        color: this.theme.menu_color,
        fontWeight: 700
      }
    },
    myPriceStyle () {
      let styles = {
        fontSize: '16px',
        verticalAlign: 'middle',
        color: this.theme.menu_price_color
      }
      if (!this.itemAvailable || this.afterPresetDiscountPrice) {
        styles.textDecoration = 'line-through'
      }
      return styles
    },
    mySoldOutStyle () {
      return {
        border: `1px solid ${this.theme.menu_price_color}`,
        borderRadius: '4px',
        fontSize: 'small',
        color: this.theme.menu_price_color,
        marginLeft: '6px',
        padding: '1px 6px',
      }
    },
    presetDiscountPriceStyle () {
      return {
        // border: `1px solid ${this.theme.menu_price_color}`,
        borderRadius: '4px',
        fontSize: '16px',
        color: this.theme.menu_price_color,
        // marginLeft: '6px',
        padding: '1px 6px',
      }
    },
    itemAvailable () {
      return parseInt(this.item.is_enabled) === 1 &&
        (this.item.inventory_left.toUpperCase() === 'NA' || parseInt(this.item.inventory_left) > 0) &&
        (this.item.inventory_left.toUpperCase() === 'NA' || parseInt(this.item.inventory_left) >= this.item.min_quantity)
    },
    itemName () {
      let name
      if (this.language !== 'en-SG') {
        name = this.item.alternate_name || this.item.name
        if (this.multiplePlus) name += ' (' + (this.item.portion_size_alternatename ? this.item.portion_size_alternatename : this.item.portion_size_name) + ')'
      } else {
        name = this.item.name
        if (this.multiplePlus) name += ' (' + this.item.portion_size_name + ')'
      }
      return name
    },
    maxQty () {
      if (!this.item.max_quantity) return 10
      return this.item.max_quantity
    },
    availablePresetDiscount() {
      return this.calculateAvailablePresetDiscount(this.item, this.user, 1);
    },
    afterPresetDiscountPrice() {
      if (!this.availablePresetDiscount) {
        return null;
      }

      return this.calculateAfterPresetDiscountPriceByItem(this.availablePresetDiscount, this.item, 1);
    }
  },
  methods: {
    orderItem (direct) {
      if (!this.itemAvailable) return
      if (this.rInfoExpiredAlert()) {
        return
      } else if (this.mode.isDelivery && this.noAddressAlert()) {
        return
      }
      if (this.iOS && this.inIframe) {
        this.$router.push({ name: 'menu_item', params: { return: 'menu' }})
      }
      if (!direct || (this.item.courses && this.item.courses.length > 0)) {
        this.$store.dispatch('menu/showMenuItemDialog', this.item)
      } else {
        this.addToCart()
      }
    },
    async addToCart () {
      if (this.rInfoExpiredAlert()) {
        return
      } else if (this.mode.isDelivery && this.noAddressAlert()) {
        return
      }
      if (this.cartLimitReached(this.item.plu_id)) {
        this.$store.dispatch('responseMessage', {
          type: 'error',
          title: 'Unable to add',
          text: this.$t('error_cart_limit'),
          modal: true
        })
        return
      }
      if (this.itemQtyInCart(this.item.plu_id) < this.maxQty) {
        this.$store.dispatch('menu/changeMenuItemQty', 1)
      }
      this.$store.dispatch('menu/setMenuItemSpecialReq', '')
      const params = {
        item: JSON.parse(JSON.stringify(this.item)),
        quantity: 1,
        final_price: parseFloat(this.item.final_price || this.item.price),
      }
      await this.$store.dispatch('cart/addCartItem', params)

      this.$store.dispatch('responseMessage', {
        type: 'success',
        text: this.$t('successfully_added_item'),
        timeout: 1800
      })
    }
  }
}
</script>

<style scoped>
.cat-item {
  font-size: 17px;
  min-height: 40px;
  cursor: pointer;
}
.food-img {
  border-radius: 5px;
  object-fit: cover;
  position: relative;
}
.nowrap-text {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.legends {
  margin-top: -3px;
  margin-bottom: -5px;
}
.feature-icon-img {
  margin-left: 4px;
}
.sold-out-bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 0.4);
  color: white;
  z-index: 1;
}
.sold-out-text {
  font-size: 18px;
  color: white;
  background-color: #e34f4f;
  padding: 3px 8px 3px 8px;
  transform: rotate(-5deg);
}
</style>



// WEBPACK FOOTER //
// src/components/ListCatItem.vue